// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3Ap2d","colMin":"styles_colMin__2SFBF","colCheckbox":"styles_colCheckbox__2guKg"};